import { memo, PropsWithChildren, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectChartPanesConfig, selectChartSeriesGroups } from '../../../selectors/chart'
import ChartPaneActions from '../chartPaneActions'
import { createPortal } from 'react-dom'
import SeriesMetadataDisplay from '../seriesMetaDisplay/seriesMetadataDisplay'
import './chartPane.css'
import ChartContextMenuButton from '../chartContextMenuButton/chartContextMenuButton'
import ChartContextMenuOptions from '../chartContextMenuOptions/chartContextMenuOptions'
import { SeriesGroup } from '../chart.typings'
import { ViewType } from '../../../assets/constants'
import { ChartContext } from '../chart.context'
import { TradeOptions } from '../../../reducer/scalper.reducer'

export type ChartPaneProps = PropsWithChildren<{
    viewKey: string,
    id: string,
    index: number,
    primaryChart: boolean
    // config: PaneConfig,
    container: HTMLDivElement
    showLogo: boolean,
    tradeOptions?: TradeOptions,
    onSecuritySelected?: (key: string, expressionMode: boolean, securities: string[]) => void
    screenerChart: boolean

}>

const ChartPane: React.FC<ChartPaneProps> = ({viewKey, id, index, container, showLogo, screenerChart, primaryChart, tradeOptions, onSecuritySelected }) => {
    const {hoverActive} = useContext(ChartContext) || {}
    const [paneContainer, setPaneContainer] = useState<HTMLDivElement>();
    const panesConfig = useSelector(selectChartPanesConfig(viewKey));
    const seriesGroups = useSelector(selectChartSeriesGroups(viewKey))
    const pane = panesConfig[id]
    const [anchorPositionContextMenu, setAnchorPositionContextMenu] = useState<{
        x: number,
        y: number,
        price: string,
        position: 'left' | 'right',
        seriesGroup: SeriesGroup | undefined
    }>({ x: 0, y: 0, price: '', position: 'left', seriesGroup: undefined })

    const currentIndex = useRef(index)
    const renderContextMenu = useMemo(() => anchorPositionContextMenu.x !== 0 && anchorPositionContextMenu.y !== 0, [anchorPositionContextMenu])

    const updatePaneContainer = useCallback(() => {
        if (!container) return
        let child = container.querySelector<HTMLDivElement>(`.chart-pane-container`)
        if (child) {
            setPaneContainer(child)
        } else {
            const child = document.createElement('div')
            child.classList.add('chart-pane-container')
            const containerStyle: Record<string, string> = {
                display: 'flex',
                'flex-direction': 'column',
                'z-index': '3',
                'justify-content': 'start',
                'align-items': 'start',
                width: '100%'
            }

            for (let key in containerStyle) {
                child.style.setProperty(key, containerStyle[key]!)
            }
            container.appendChild(child)
            setPaneContainer(child)
        }

    }, [container])

    useEffect(() => {
        currentIndex.current = index
    }, [index])

    useEffect(() => {
        updatePaneContainer()
    }, [index, updatePaneContainer])


    return <>
            {paneContainer && pane && createPortal(<>
                <div className="pane-meta-container">
                    {
                        pane.seriesGroups.map((sgid) => <SeriesMetadataDisplay tradeOptions={tradeOptions} seriesGroup={seriesGroups[sgid]} key={sgid} screenerChart={screenerChart} primaryChart={primaryChart} onSecuritySelected={onSecuritySelected} view={ViewType.CHART}/>)
                    }
                </div>
                { !screenerChart ? <ChartPaneActions index={index} primary={pane.primary} /> : null }
                { pane.primary && !screenerChart && primaryChart && hoverActive && <ChartContextMenuButton setAnchorPositionContextMenu={setAnchorPositionContextMenu} paneContainer={paneContainer} paneIndex={currentIndex.current} viewKey={viewKey} />}
                { !screenerChart && primaryChart && renderContextMenu && <ChartContextMenuOptions anchorPosition={anchorPositionContextMenu} setAnchorPosition={setAnchorPositionContextMenu} viewKey={viewKey} />}
            </>, paneContainer)}
            
        </>
}

export default memo(ChartPane)